"use client";

import styled from "@emotion/styled";

type StyledIconWrapperProps = {
  $color: string;
};

export const StyledIconWrapper = styled("span", {
  shouldForwardProp: prop =>
    !["$color"].includes(prop as keyof StyledIconWrapperProps),
})<StyledIconWrapperProps>`
  svg {
    color: ${({ $color }) => $color};
  }
`;
